import React, { PropsWithChildren } from 'react';

import styles from './container-component.module.css';

export const Container: React.FC<PropsWithChildren<{}>> = ({ children }: PropsWithChildren<{}>) => {
    return <div className={styles.mentions}>{children}</div>;
};
